import { createContext, useContext } from 'react';
import { useAsyncData } from '../hooks/useAsyncData';
export const CardContext = /*#__PURE__*/createContext({});
export const useSetCardContextValue = (props, context) => {
  const {
    objectTypeId,
    objectId
  } = context;
  if (!objectTypeId || !objectId) {
    throw new Error('objectTypeId and objectId are required');
  }
  const asyncData = useAsyncData(objectTypeId, objectId);
  return {
    objectTypeId,
    objectId,
    propertyNames: props.cardData.configuration.propertyNames,
    asyncData
  };
};
const isInitializedContext = context => {
  return Object.keys(context).length > 0;
};
export const useCardContextValue = () => {
  const context = useContext(CardContext);
  if (!isInitializedContext(context)) {
    throw new Error('CardContext has not been initialized yet');
  }
  return context;
};